export class RequestFilter {
    id: number = 0;
    corporateName: string = "";
    negRef: string = "";
    popId: number = 0;
    status: string = "";
    manager: string = "";
    frontOffice: string = "";
    startDate: string = "";
    endDate: string = "";
    credit: string = "";
    dealer: string = "";
    pac: string = "";
    negId: number = 0;
    clientId: string = "";
    authorizedToConfirm: boolean = false;
}